import { Alert, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

interface CallBackMessageAlertProps {
  onCallbackEwaybillAccountId?(ewaybillAccountId: number): void;
}

interface CallbackData {
  /**
   * 'true' | 'false'
   */
  success?: string;

  message?: string;

  ewaybillAccountId?: number;
}

const CallBackMessageAlert: React.FC<CallBackMessageAlertProps> = function (props) {
  const location = useLocation();
  const [data, setData] = useState<CallbackData>();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const success = params?.get("success");
    const message = params?.get("message");
    const rawEwaybillAccountId = params?.get("ewaybillAccountId");

    if (success === "false" && message) {
      Modal.error({
        title: "发生错误",
        content: message,
      });
    } else {
      const ewaybillAccountId = Number(rawEwaybillAccountId);

      setData({
        success,
        message,
        ewaybillAccountId,
      });

      props?.onCallbackEwaybillAccountId?.(ewaybillAccountId);
    }
  }, [location.search]);

  if (data?.success === "true" && data?.message) {
    return (
      <Alert
        className="mb10"
        showIcon
        type="success"
        message={data?.message}
        closable
        onClose={() => {
          setData(null);
        }}
      />
    );
  }

  return null;
};

export default CallBackMessageAlert;
